/* eslint-disable import/prefer-default-export */
import { css } from '@emotion/core';
import { media } from '@domain-group/fe-brary';
export var container = /*#__PURE__*/css("padding-top:6px;margin-bottom:23px;", media('>=desktop'), "{width:970px;margin:0 auto 55px;}");